import { createBoard, type Board, type Element } from "./board";

export function createStarterBoard(): Board {
  const board = createBoard();
  const starters: Array<[number, number, Element]> = [
    [1, 1, "fire"], [4, 2, "fire"], [8, 1, "fire"],
    [2, 5, "ice"], [5, 5, "ice"], [8, 7, "ice"],
    [3, 9, "lightning"], [7, 9, "lightning"], [10, 10, "lightning"],
  ];
  for (const [x, y, element] of starters) {
    board.cells[y * board.width + x] = { id: `demo-${x}-${y}`, element, tier: 1 };
  }
  return board;
}
